import { CmStreamType } from '../cta/CmStreamType.js';

/**
 * Common Media Server Data Stream Type
 *
 * @group CMSD
 *
 * @enum
 *
 * @beta
 */
export const CmsdStreamType = CmStreamType as typeof CmStreamType;

/**
 * @beta
 */
export type CmsdStreamType = CmStreamType;
